"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.176.2
//   protoc               v4.23.4
// source: tac-operation-lifecycle-proto/proto/v1/tac-operation-lifecycle.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationStage_StageType = exports.BlockchainType = exports.OperationType = void 0;
/* eslint-disable */
var OperationType;
(function (OperationType) {
    OperationType["ERROR"] = "ERROR";
    OperationType["PENDING"] = "PENDING";
    OperationType["TON_TAC_TON"] = "TON_TAC_TON";
    OperationType["TAC_TON"] = "TAC_TON";
    OperationType["TON_TAC"] = "TON_TAC";
    OperationType["ROLLBACK"] = "ROLLBACK";
    OperationType["UNKNOWN"] = "UNKNOWN";
    OperationType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(OperationType || (exports.OperationType = OperationType = {}));
var BlockchainType;
(function (BlockchainType) {
    BlockchainType["TAC"] = "TAC";
    BlockchainType["TON"] = "TON";
    BlockchainType["UNKNOWN_BLOCKCHAIN"] = "UNKNOWN_BLOCKCHAIN";
    BlockchainType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(BlockchainType || (exports.BlockchainType = BlockchainType = {}));
var OperationStage_StageType;
(function (OperationStage_StageType) {
    OperationStage_StageType["COLLECTED_IN_TAC"] = "COLLECTED_IN_TAC";
    OperationStage_StageType["INCLUDED_IN_TAC_CONSENSUS"] = "INCLUDED_IN_TAC_CONSENSUS";
    OperationStage_StageType["EXECUTED_IN_TAC"] = "EXECUTED_IN_TAC";
    OperationStage_StageType["COLLECTED_IN_TON"] = "COLLECTED_IN_TON";
    OperationStage_StageType["INCLUDED_IN_TON_CONSENSUS"] = "INCLUDED_IN_TON_CONSENSUS";
    OperationStage_StageType["EXECUTED_IN_TON"] = "EXECUTED_IN_TON";
    OperationStage_StageType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(OperationStage_StageType || (exports.OperationStage_StageType = OperationStage_StageType = {}));
